<template>
  <div class="examine-sql-detail">
    <template v-if="isloading">
      <van-loading size="30px" vertical>
        <span style="font-size:16px">加载中...</span>
      </van-loading>
    </template>
    <template v-else>
      <template v-if="sqlDetail != null">
        <div class="status">
          <div>{{sqlDetail.username||'xxx'}}的SQL审批单</div>
          <!-- 待审核 -->
          <div class="state state-0" v-if="sqlDetail.auditStatus==0"></div>
          <!-- 审核通过 -->
          <div class="state state-1" v-if="sqlDetail.auditStatus==1 || sqlDetail.auditStatus==4"></div>
          <!-- 审核拒绝 -->
          <div class="state state-2" v-if="sqlDetail.auditStatus==2"></div>
        </div>
        <div class="divider"><i>基本信息</i></div>
        <div class="con">
          <ExamineCell label="提交人" :value="sqlDetail.username||''" />
          <ExamineCell label="提交时间" :value="sqlDetail.createTime||''" />
          <ExamineCell label="工单类型" :value="sqlDetail.type|typeName" />
          <ExamineCell label="机房" :value="sqlDetail.computerRoom||''" />
          <ExamineCell label="连接名称" :value="sqlDetail.connectionName||''" />
          <ExamineCell label="数据库名" :value="sqlDetail.basename||''" />
          <ExamineCell label="审核状态" :value="sqlDetail.auditStatus|checkStatus" />
          <ExamineCell label="拒绝原因" :value="sqlDetail.rejected" v-if="sqlDetail.auditStatus==2" />
        </div>
        <template v-if="sqlDetail.sqlText">
          <div class="divider" style="margin-top: 40px"><i>SQL详情</i></div>
          <div class="codeView" v-highlight>
            <pre><code class="codecon" v-html="sqlDetail.sqlText"></code></pre>
          </div>
        </template>
        <div class="footer" v-if="sqlDetail.auditStatus==0">
          <van-button class="combutt" type="primary" @click="checkPass">审核通过</van-button>
          <van-button class="combutt" type="danger" @click="showDialog=true">审核驳回</van-button>
          <van-button class="combutt" type="warning" @click="checkCancel">审核撤销</van-button>
        </div>
      </template>
      <template v-else>
        <van-empty description="审批单已撤销！" />
      </template>
    </template>

    <van-dialog :beforeClose="checkBack" v-model="showDialog" class="cancel-dialog" title="温馨提示" show-cancel-button>
      <input v-model="failReason" class="failReason" placeholder="请输入驳回原因" type="text">
    </van-dialog>
  </div>
</template>

<script>
import TeslaHTTP from '@api/tesla';
import ExamineCell from './components/examine-cell';

export default {

  components: { ExamineCell },

  data() {
    return {
      isloading: true,
      params: {
        openId: '',
        id: '',
      },
      sqlDetail: {}, // 表单详情
      showDialog: false, // 显示拒绝框
      failReason: '', // 拒绝原因
    };
  },

  created() {
    const { openId = '', id = '' } = this.$route.query;
    this.params = {
      openId,
      id,
    };
    if (!id) {
      this.$toast('参数错误');
    } else {
      this.prepareData();
    }
  },

  methods: {

    // 加载页面数据
    prepareData() {
      this.isloading = true;
      TeslaHTTP.orderSelect({ id: this.params.id }).then((resp) => {
        console.log('success');
        this.isloading = false;
        if (resp) {
          this.sqlDetail = resp;
        } else {
          this.sqlDetail = null;
        }
      }).catch(() => {
        console.log('catch');
        this.isloading = false;
      });
    },

    // 审核通过
    checkPass() {
      this.$dialog.confirm({
        title: '温馨提示',
        message: '是否确认通过该审核？',
      }).then(resp => {
        TeslaHTTP.firstPass({ id: this.params.id }).then((resp) => {
          this.$notify({ type: 'success', message: '已审核通过' });
          this.prepareData();
        });
      }).catch(() => { });
    },

    // 审核拒绝
    checkBack(action, done) {
      if (action == 'cancel') {
        return done();
      }
      if (!this.failReason) {
        this.$toast('请输入拒绝原因');
        return done(false);
      }
      const _params = {
        id: this.params.id,
        rejected: this.failReason,
      };
      TeslaHTTP.refuse(_params).then((resp) => {
        this.$notify({ type: 'success', message: '已审核拒绝' });
        this.prepareData();
        done();
      }).catch(() => {
        done(false);
      });
    },

    // 撤销
    checkCancel() {
      this.$dialog.confirm({
        title: '温馨提示',
        message: '是否确认撤销操作？',
      }).then(resp => {
        TeslaHTTP.undo({ id: this.params.id }).then((resp) => {
          this.$notify({ type: 'success', message: '已撤销' });
          this.prepareData();
        });
      }).catch(() => { });
    },
  },

  filters: {
    checkStatus(value) {
      let statusName = '-';
      switch (value) {
        case 0:
          statusName = '待审核';
          break;
        case 1:
          statusName = '初审通过';
          break;
        case 2:
          statusName = '审核驳回';
          break;
        case 3:
          statusName = '已撤销';
          break;
        case 4:
          statusName = '复审通过';
          break;
        default:
          break;
      }
      return statusName;
    },

    typeName(value) {
      let typeName = '-';
      switch (value) {
        case 0:
          typeName = 'DDL';
          break;
        case 1:
          typeName = 'DML';
          break;
        default:
          break;
      }
      return typeName;
    },
  },
};
</script>

<style lang="scss" scoped>
.examine-sql-detail {
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  font-size: 38px;
  padding: 20px 10px 120px 10px;
  box-sizing: border-box;
  background-image: url('https://web-data.zmlearn.com/image/e1TbQEfAYKeip6NvYeXqF7/apple-bg.png');

  .con {
    width: 700px;
    margin: 0 auto 20px auto;
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.28);
    border-radius: 6px;
  }

  .codeView {
    width: 700px;
    margin: auto;
    font-size: 22px;
    line-height: 38px;
    box-sizing: border-box;
    box-shadow: 0 1px 6px 0 rgba(32, 33, 36, 0.28);
    border-radius: 6px;
    .codecon {
      padding: 10px;
      border-radius: 6px;
      white-space: break-spaces;
    }
  }
  // 华丽的分割线
  .divider {
    font-size:32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0;
    i {
      margin: 0 20px;
      flex-shrink: 0;
      color: #666;
      font-weight: bold;
    }
    &::after,
    &::before {
      content: '';
      width: 260px;
      height: 2px;
      background-color: #999;
      display: block;
    }
  }

  .footer {
    width: 100%;
    height: 100px;
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.88);
    display: flex;
    justify-content: space-around;
    align-items: center;
    .combutt {
      width: 200px;
      height: 60px;
      border-radius: 6px;
    }
  }
  .cancel-dialog {
    font-size: 32px;
    border-radius: 10px;

    // /deep/.van-dialog__content {
    //   padding: 24px;
    //   padding-top: 12px;
    //   color: #646566;
    //   text-align: center;
    //   font-size: 28);
    // }

    .failReason {
      background: #eeeef4;
      width: 100%;
      height: 75px;
      padding-left: 40px;
      border-radius: 10px;
      box-sizing: border-box;
      color: #8a8a8a;
      &::placeholder {
        color: #8a8a8a;
      }
    }
  }

  .status {
    text-align: center;
    font-weight: bold;
    height: 160px;
    line-height: 160px;

    position: relative;
    .state {
      width: 170px;
      height: 130px;
      position: absolute;
      right: 0;
      top: 0;
      opacity: 0.6;
    }
    .state-0 {
      background: url('https://web-data.zmlearn.com/image/ft7p4BzBamX937JDqwvxmx/check-wait.png')
        no-repeat;
      background-size: 100% 100%;
    }
    .state-1 {
      background: url('https://web-data.zmlearn.com/image/fqpufn1Njkxuys2yCWBJ8U/check-pass.png')
        no-repeat;
      background-size: 100% 100%;
    }
    .state-2 {
      background: url('https://web-data.zmlearn.com/image/cH46eMegV8EofgD1DW4Hrk/check-reject.png')
        no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
<style lang="scss">
.examine-sql-detail {
  .cancel-dialog {
    .van-dialog__content {
      padding: 24px;
      padding-top: 12px;
      color: #646566;
      text-align: center;
      font-size: 28px;
    }
  }
}
</style>